import imgPropostaAceita from '@/assets/images/quite-piscando.gif';
import { StatusProposta } from '@/models/enums';
import { BusinessRules } from '../BusinessRules';
import compMsgEmissaoParcelaSuspensa from '../components/standard/compMsgEmissaoParcelaSuspensa.vue';
import compMsgAcompanhamentoBoletoPosEntrada from '../components/standard/msgAcompanhamentoBoletoPosEntrada.vue';
import compMsgBoletoSemOperacao from '../components/standard/msgBoletoSemOperacao.vue';
import compMsgErroRegerarParcela from '../components/standard/msgErroRegerarParcela.vue';

/** porcentagem mínima para exibir % de desconto */
const porcentagemMinimaExibicaoDesconto = 30;

const statusQueExibemPropostaDescricao = new Set([StatusProposta.Aceita, StatusProposta.Quitada]);

const rules: BusinessRules = {
  disponibilizarSomentePrimeiraParcela: () => false,
  compMsgBoletoSemOperacao,
  compMsgAcompanhamentoBoletoPosEntrada,
  compMsgErroRegerarParcela,
  compMsgCancelamentoSucesso: null,
  compMsgCancelamentoViaCredor: null,
  compMsgCancelamentoErroApi: null,
  compMsgCancelamentoErroIndisponibilidade: null,
  compMsgDebitoEmConta: undefined,
  compMsgEmissaoParcelaSuspensa,
  mensagemBoletoEmFilaEmissao: 'Em breve os dados de pagamento estarão disponíveis. ',
  mensagemDebitoAutomatico: undefined,
  // eslint-disable-next-line max-len
  mensagemAcompanhamentoAplicativo:
    'Após o pagamento da primeira parcela, o restante da sua negociação poderá ser acompanhado diretamente no canal do credor.',
  mensagemTermoCondicoesGerais:
    'Ao continuar, você declara que leu e concorda com as informações descritas no documento de',
  mensagemUrlTermoCondicoesGerais: 'termos e condições',
  mensagemAcompanhamentoCanalOficial:
    'Acompanhe sua negociação e acesse todas as informações de pagamento diretamente no canal oficial',
  textoBotaoCanalOficial: 'Acessar canal oficial',
  // eslint-disable-next-line max-len
  mensagemColchaoNaoGerenciado:
    'Todas as atualizações das parcelas não gerenciadas neste canal devem ser acompanhadas exclusivamente no canal do credor. Nele você encontrará informações detalhadas sobre o status dos seus pagamentos.',
  linkAplicativo: undefined,
  nomeAplicativo: undefined,
  aplicativoMobile: false,
  permiteBaixarPdfBoleto: true,
  mostrarAvisoNegociadoComValorAdicional: false,
  mostrarProprietarioDivida: false,
  showAvisoSenhaBoleto: false,
  isCardDividaDiferenciado: () => false,
  imagemPropostaAceita: imgPropostaAceita,
  validatePropostaShowDesconto: p => p.percentualDesconto >= porcentagemMinimaExibicaoDesconto,
  // eslint-disable-next-line max-len
  showUltimaPropostaDescricao: proposta => statusQueExibemPropostaDescricao.has(proposta.status),
  showAvisoValorOfertaAteVencimento: () => true,
  showValorOriginal: true,
  permiteCancelarViaCredor: false,
  permiteNegociacaoParcial: false,
  considerarFgtsNoResumoAcordo: false,
  mostrarErroRegerarParcela: () => false,
  showLogoTelaBoletos: () => false,
  showLogoTelaPropostas: () => false,
};

export default rules;
